<div class="multivenue-wrapper">
  <div class="tabs-content">
    <div class="selector-div-wrapper">
      <span>Mostrar</span>
      <div class="form-check form-switch">
        <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="multivenue-switch"
          [(ngModel)]="tool.enabled" [checked]="tool.enabled" (change)="onSwitcherChange($event)" />
      </div>
    </div>

    <div class="selector-div-wrapper" *ngIf="tool.enabled">
      <span>Posición</span>
      <div class="selector-div">
        <select name="selector" id="selector" (change)="onSelectPosition($event)">
          <option [selected]="tool.position === 'lateral'" [ngValue]="'lateral'">Lateral</option>
          <option [selected]="tool.position === 'top'" [ngValue]="'top'">Arriba</option>
        </select>
        <div class="vertical-line"></div>
      </div>
    </div>

    <div *ngIf="tool.enabled">
      <div class="tabs">
        <div class="tab">
          <button (click)="toggleInterface('list')" [ngClass]="{ active: tabs.list }">Lista</button>
        </div>
        <div class="tab">
          <button (click)="toggleInterface('create')" [ngClass]="{ active: tabs.create }">Crear</button>
        </div>
      </div>
      <div class="venues-list" #list [hidden]="tabs.create">
        <div class="d-flex align-items-center">
          <table class="venues-table">
            <tr>
              <th>Venue</th>
              <th>Logo/Nombre</th>
              <th>Acciones</th>
            </tr>
            <!-- Main Site Venue Tab -->
            <tr *ngFor="let venue of tool.venues; index as i" [ngClass]="{
                'fixed-tab': venue.venueId === originalDVMIds.venueid && venue.mapId === originalDVMIds.mapid
              }">
              <td>{{ venue.venueId }}</td>
              <td>
                <span *ngIf="venue.name" class="venue-text">{{ venue.name }}</span>
                <img *ngIf="venue.type === 'icon' && (venue.file || venue.logoPreview)" class="venue-icon"
                  [src]="venue.logoPreview" alt="logo preview" />
              </td>
              <td class="venue-btns">
                <button *ngIf="!(venue.venueId === originalDVMIds.venueid && venue.mapId === originalDVMIds.mapid)"
                  class="action-btn" (click)="deleteVenueTab(venue)" [disabled]="!this.tool.enabled" title="Delete">
                  <img id="delete" alt="" />
                </button>
                <button class="action-btn" (click)="toggleEditVenueTabMode(venue, venue === tool.venues[0])"
                  [disabled]="!this.tool.enabled"
                  [ngClass]="{ active: editVenueTabMode && editVenueTab.id === venue.id }" title="Edit">
                  <img id="edit" alt="" />
                </button>

                <div>
                  <button [ngClass]="{ invisible: i === 0 }" class="action-btn half-up"
                    (click)="changeOrder(venue, 'up')" [disabled]="!this.tool.enabled" title="Move up">
                    <img src="/assets/img/arrow-down.svg" alt="" />
                  </button>
                  <button [ngClass]="{ invisible: i === tool.venues.length - 1 }" class="action-btn half-down"
                    (click)="changeOrder(venue, 'down')" [disabled]="!this.tool.enabled" title="Move down">
                    <img src="/assets/img/arrow-down.svg" alt="" />
                  </button>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="editVenueTabMode" class="mt-3" [hidden]="!tabs.list">
          <app-multivenue-item #multivenueItem [venueTab]="editVenueTab" [mode]="'edit'" [isDefaultTab]="isDefaultTab"
            (editedVenueTab)="onEditVenueTab($event)"></app-multivenue-item>
        </div>
      </div>
      <div #create [hidden]="!tabs.create">
        <app-multivenue-item #multivenueItem [mode]="'create'" [venueTab]="newVenueTab"
          (createdVenueTab)="onCreateVenueTab($event)"></app-multivenue-item>
      </div>
    </div>
  </div>
  <div class="tabs-bottom">
    <button class="btn-secondary-action" (click)="checkBeforeApply()">Aplicar cambios</button>
  </div>
</div>